export default "__VITE_ASSET__KnLI0y9q__"